import { commonConfig } from './commonConfig';

/**
 * Client only variables
 */
export const clientConfig = Object.freeze({
  ...commonConfig,

  // isExported: ,
  isDebug: process.env.NEXT_PUBLIC_DEBUG === 'true',
  intlLocale: 'ru-RU',
  selfUrl: process.env.NEXT_PUBLIC_SELF_URL_BASE!,
  appUrl: process.env.NEXT_PUBLIC_APP_URL, // Url to webapp for myhub
  defaultProfileBaseCurrency: 'USD',
  inboxEmailDomain: process.env.NEXT_PUBLIC_INBOX_EMAIL_DOMAIN,
  googleAuthClientId: process.env.NEXT_PUBLIC_GOOGLE_AUTH_CLIENT_ID ?? '',
  oprfPublicKey: process.env.NEXT_PUBLIC_PIN_OPRF_PUBLIC_KEY,

  //
  enableDocumentOcr: process.env.NEXT_PUBLIC_ENABLE_DOCUMENTS_OCR,

  api: {
    isPersistCache: process.env.NEXT_PUBLIC_PERSIST_CACHE === 'true',
    graphqlUrl: process.env.NEXT_PUBLIC_GRAPHQL_API_URL!,
    directGraphqlUrl: process.env.NEXT_PUBLIC_DIRECT_GRAPHQL_API_URL!,
    gtwUrl: process.env.NEXT_PUBLIC_GTW_URL,

    isGraphqlMergedRequestEnabled:
      process.env.NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_ENABLED === 'true',
    graphqlMergedRequestBatchMax: process.env.NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_BATCH_MAX,
    graphqlMergedRequestBranchInterval:
      process.env.NEXT_PUBLIC_MERGED_GRAPHQL_REQUESTS_BATCH_INTERVAL,

    clientVersionHeader: '1.0.0',
    clientPlatformHeader: 'web',

    collectionPlatformKey: 'web',
  },

  demoHub: {
    isDemoHub: process.env.NEXT_PUBLIC_DEMO_HUB_SEED_PHRASE !== undefined,
    mnemonic: process.env.NEXT_PUBLIC_DEMO_HUB_SEED_PHRASE,
    defaultReturnUrl: 'https://owner.one',
  },

  devFlags: {
    skipLocalMigrations: process.env.NEXT_PUBLIC_DEV_SKIP_LOCAL_MIGRATIONS === 'true',
  },

  socketUrls: {
    chat: process.env.NEXT_PUBLIC_CHAT_URL ?? 'https://chat.owner.one/chat',
    auth: process.env.NEXT_PUBLIC_AUTH_URL ?? 'https://auth.owner.one/ws',
    case: process.env.NEXT_PUBLIC_CASE_URL ?? 'https://case.owner.one/ws',
  },
});
